<template>
  <v-container fluid grid-list-md ma-0 pa-0>
    <v-layout class="pa-md-4" row wrap>

      <v-flex> 
        <v-select
          v-model="domFilter"
          :items="business"
          label="Filter by business"
          solo
          hint="Select your business"
          persistent-hint
        ></v-select>
      </v-flex>
      <v-flex>
        <v-btn large color="primary" @click="getfilteredData">
          Search
        </v-btn>
      </v-flex>
      <v-row justify="center">
        <v-snackbar v-model="snackbar" color="accent" :timeout="timeout" bottom>
          Please use the select boxes at the top to filter templates
          <v-btn dark text @click="snackbar = false">
            Close
          </v-btn>
        </v-snackbar>
      </v-row>
      <v-row justify="center">
      
      </v-row>

      <ecom-render
        :index="pageIndex"
        :cards="myJson"
        :key="pageId"
      ></ecom-render>
    </v-layout>
  </v-container>
</template>

<script>
import wooData from "@/woocommerce";
import EcomRender from "@/components/EcomRender";
export default {
  name: "ExploreEcommerce",
  components: {
    "ecom-render": EcomRender
  },
  data: () => ({
    panel: 0,
    noArrows: false,
    snackbar: true,
    timeout: 25000,
    pageIndex: 0,
    pageId: 0,
    techFilter: "WooCommerce",
    domFilter: "All",
    myJson: [],
    woocommerce: [],
    prestashop: [],
    opencart: [],
    initJson: wooData,
    technology: ["PrestaShop", "OpenCart", "WooCommerce"],
    business: [
      "All",
      "Generic",
      "Automobiles",
      "Beauty & Cosmetics",
      "Books",
      "Electronics & Gadgets",
      "Fashion",
      "Food & Beverage",
      "Furniture",
      "Health & Fitness",
      "Plants & Gardening",
      "Pets",
      "Others"
    ]
  }),
  methods: {
    getfilteredData() {
      this.pageId++;
      this.pageIndex = 0;
      if (this.techFilter == "" || this.techFilter == "PrestaShop")
        this.initJson = this.prestashop;
      else if (this.techFilter == "OpenCart") this.initJson = this.opencart;
      else this.initJson = this.woocommerce;
      this.myJson = [];
      this.$router.replace({
        path: "/explore-ecommerce",
        query: { tech: this.techFilter, dom: this.domFilter }
      });
      if (this.domFilter == "" || this.domFilter == "All") {
        this.myJson = this.initJson;
      } else {
        var filter1 = this.domFilter;
        this.myJson = this.initJson.filter(function(itm) {
          return itm.tags == filter1;
        });
      }
    }
  },
  created() {
    this.woocommerce = wooData;
    if (this.$route.query.dom == null && this.$route.query.tech == null)
      this.getfilteredData();
    else {
      this.techFilter = this.$route.query.tech;
      this.domFilter = this.$route.query.dom;
      this.getfilteredData();
    }
  }
};
</script>
